import { ShieldCheck, Sparkles, Gauge, Users } from "lucide-react";

const MAP = {
  verified: { label: "Verified Data", color: "#0EA5E9", icon: ShieldCheck },
  ai: { label: "AI Analysis", color: "#8B5CF6", icon: Sparkles },
  estimated: { label: "Estimated", color: "#F59E0B", icon: Gauge },
  community: { label: "Community Submitted", color: "#10B981", icon: Users },
};

export default function ProvenanceTag({ type = "ai", className = "" }) {
  const cfg = MAP[type] || MAP.ai;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-mono uppercase tracking-wider border ${className}`}
      style={{ color: cfg.color, borderColor: `${cfg.color}40`, background: `${cfg.color}12` }}
      data-testid={`provenance-${type}`}
    >
      <Icon className="w-3 h-3" />
      {cfg.label}
    </span>
  );
}
